import { useDispatch, useSelector } from "react-redux"
import InputGroup from "react-bootstrap/InputGroup"
import Form from "react-bootstrap/Form"
import { teamStatus } from "state_management"
import useT from "utils/hooks/useT"

export default function IncludeTodayButton() {
  const { t } = useT("common")
  const dispatch = useDispatch()
  const includeToday = useSelector((state) => state.teamStatus.includeToday)

  return (
    <InputGroup style={{ marginTop: "20px" }}>
      <Form.Check
        checked={includeToday}
        type={"checkbox"}
        id={`include-today-checkbox`}
        onChange={(e) => dispatch(teamStatus.includeToday({ iapToday: e.target.checked }))}
      />
      <div className="Include-today">
        <p>{t("includeToday")}</p>
      </div>
    </InputGroup>
  )
}
